// extracted by mini-css-extract-plugin
export const root = "BackgroundBlock-module--root--Z-WPt";
export const imgItem = "BackgroundBlock-module--img-item--2ngMk";
export const alignContainer = "BackgroundBlock-module--align-container--3ozLP";
export const LEFT = "BackgroundBlock-module--LEFT--1JW0i";
export const RIGHT = "BackgroundBlock-module--RIGHT--xz0KO";
export const CENTER = "BackgroundBlock-module--CENTER--14zE2";
export const mobileContainer = "BackgroundBlock-module--mobile-container--12Iqr";